module.exports = __webpack_public_path__ + "img/CZK.33610069.svg";